import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import Content from 'components/base/Content'
import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
// import ResponsiveImage from 'components/base/ResponsiveImage'
// import ProgressiveImage from 'components/base/ProgressiveImage'
import SectionRule from 'components/base/SectionRule/styles'
import Link from 'components/base/Link'

import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import AskQuestion from 'components/blocks/AskQuestion'
import RetailLounge from 'components/blocks/RetailLounge'

// import LocationImage from 'assets/images/locations/beaverton.webp'
// import LocationImage64 from 'assets/images/locations/beaverton-placeholder'
import HoursNotification from 'components/blocks/HoursNotification'

import { Location } from '../../../components/App/styles'

const ReatailLoungesLasVegas: React.FC = (): React.ReactElement => (
  <div>
    <HeaderMeta
      title='Insurance Agency In Las Vegas, NV | Insurance Lounge'
      description='Insurance Lounge is your one-stop-shop for insurance coverage in Las Vegas, Nevada. Shop Home, Auto, Life, Health & other insurance policies in seconds.'
      ogImg='/images/og-images/Beaverton.webp'
    />
    <PageHero theme={PageHeroTheme.lasVegas} right={true} cta={true}>
      Insurance Agency In Las Vegas, NV
    </PageHero>
    <Content short={true} center={true} margined={true}>
      <Title level={2}>
        Insurance Lounge <br />Las Vegas, NV
      </Title>
      <Paragraph theme={ParagraphTheme.introLarge}>
        At Insurance Lounge in Las Vegas, NV, we focus on technology and
        innovation to make insurance shopping easy for you. Are you in the market for insurance?
      </Paragraph>
    </Content>
    {/* <Content center={true} margined={true}>
      <ResponsiveImage width720={true}>
        <ProgressiveImage
          src={LocationImage}
          src2x={undefined}
          placeholder={LocationImage64}
          alt='Beaverton Retail Store'
        />
      </ResponsiveImage>
    </Content> */}
    <Content center={true} margined={true}>
      <RetailLounge
        hoursWeekday='9:00am ⁠– 5:00pm'
        hoursWeekend='Closed'
        phone='725-218-1434'
      >
        <Location href='https://goo.gl/maps/91uWHgHmv2ZBbb4p7' target='_blank' rel='noopener noreferrer'>
          3572 St. Rose Parkway
          <br />
          Suite 100
          <br />
          Henderson, NV 89052
        </Location>
      </RetailLounge>
      <HoursNotification hours='8:00am - 5:00pm PST' />
    </Content>
    <Content center={true} margined={true}>
      <iframe title='Map to Beaverton, OR Insurance Lounge' src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3228.392483132007!2d-115.14677638340154!3d35.98627558012419!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c8cc2a7da863b9%3A0xa470f110a62c21ff!2s3572%20St%20Rose%20Pkwy%2C%20Henderson%2C%20NV%2089052!5e0!3m2!1sen!2sus!4v1668027343447!5m2!1sen!2sus' width='600' height='450' style={{ border:0 }} loading='lazy' referrerPolicy='no-referrer-when-downgrade' />
    </Content>
    <SectionRule />
    <Content center={true} short={true} margined={true}>
      <Title level={3}>The Insurance Lounge Difference</Title>
      <Paragraph>
        Your lifestyle is unique, so your insurance coverage should be, too. At Insurance Lounge,
        we understand that there’s no one-size-fits-all solution for insurance: everyone’s circumstances
        are different. We’re a no-commission agency, so we’re more than happy to help you get exactly
        what you need. Discover the possibilities of choosing from top carriers.
      </Paragraph>
      <Title level={3}>
        An Insurance Experience Tailored to You
      </Title>
      <Paragraph>
        Shop, compare, and purchase policies from over 100 carriers by working with one of our Insurance Concierges.
        No matter how you prefer to buy insurance, we offer many ways to shop to make the process as
        painless as possible. With the help of powerful quote comparison technology, we can find you affordable
        coverage that delivers you the most value possible. Explore policies online, over the phone, or even
        stop by to visit us at our Las Vegas location. Shop insurance coverage options for:&nbsp;
        <Link to='/products/homeowners-insurance'>Home</Link>,&nbsp;
        <Link to='/products/auto-insurance'>Auto</Link>,&nbsp;
        <Link to='/products/life-insurance'>Life</Link>,&nbsp;
        <Link to='/products/health-insurance'>Health</Link>,&nbsp;
        <Link to='/products/medicare-insurance'>Medicare</Link>,&nbsp;
        <Link to='/products/disability-insurance'>Disability</Link>,&nbsp;
        <Link to='/products/business-insurance'>Business</Link>,&nbsp;
        <Link to='/products/investments-retirement'>Retirement</Link>.
      </Paragraph>
      <Title level={3}>Guaranteed Comprehensive Support</Title>
      <Paragraph>
        We’re here to <Link to='/support'>answer all of your questions</Link> and are committed to providing the
        support you need to protect your family, property, and lifestyle. Visit us in the Las Vegas area at &nbsp;
        <Location href='https://goo.gl/maps/91uWHgHmv2ZBbb4p7' target='_blank' rel='noopener noreferrer'>
          3572 St. Rose Parkway, Suite 100, Henderson, NV 89052,
        </Location>
        &nbsp;where we have friendly Insurance Concierges available to assist you in a calm, comfortable environment. You deserve a better insurance experience, which is why we offer technology that allows you to shop your way. Call 725-218-1434 or <Link to='/quote/new'>complete our form </Link> to get a quote today.
      </Paragraph>
    </Content>
    <SectionRule />
    <AskQuestion title='We’re Here, When You Need Us'>
      Reach out and an Insurance Concierge<sup>®</sup> will get in touch!
    </AskQuestion>
  </div>
)

export default ReatailLoungesLasVegas
